import { createFileRoute } from '@tanstack/react-router'
import { AuditorAssetsPage, auditorAssetSearchSchema } from '@/components/auditor-center/AuditorAssetsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets',
)({
  validateSearch: auditorAssetSearchSchema,
  component: AuditorAssetsPage,
})
